export default class Field2FA {

    constructor($view) {
        this.$view = $view;
        this.fieldType = this.$view.data('field-type');
        this.$fieldInput = this.$view.find('input[type="' + this.fieldType + '"]');
        this.$code = this.$view.find('.js-input-code');
        this.$codeInput = this.$code.find('input[type="text"]');
        this.$publicCodeInput = this.$view.find('.js-public-code')[0];
        this.sendCodeUrl = this.$view.data('send-code-url');
        this.checkCodeUrl = this.$view.data('check-code-url');
        this.$resendButton = this.$view.find('.js-resend');
        this.$codeHelp = this.$view.find('.js-code-help');
        this.mode = this.$view.data('mode');
        this.error = this.$view.data('error');
        this.minLength = this.$view.data('min-length');
        this.bind()
    }

    bind() {
        let sendCodeModes = [];
        if ('tel' === this.fieldType) {
            sendCodeModes = ['login'];
        }  else { //fieldType === 'email'
            sendCodeModes = ['login', 'edit'];
        }
        if (sendCodeModes.includes(this.mode)) {
            if (!this.error) {
                this.sendCode();
            } else {
                this.init()
            }
        } else {
            this.init()
        }

        this.$fieldInput.on('change', this.sendCode.bind(this));

        this.$codeInput.on('change', this.checkCode.bind(this));

        if (this.$resendButton) {
            this.$resendButton.on('click', (e) => {
                e.preventDefault();
                this.sendCode('resend');
            });
        }
    }

    init() {
        if (!this.$codeInput[0].value) {
            this.$codeHelp.addClass('d-none');
            this.$codeInput[0].disabled = true;
        } else {
            this.checkCode();
            this.$codeInput[0].disabled = false;
        }
    }

    sendCode(type = 'send') {
        this.init()
        const value = this.$fieldInput[0].value.trim().replace(' ', '');
        if (value.length < this.minLength) {
            return;
        }
        $.ajax({
            url: this.sendCodeUrl,
            method: 'post',
            data: {
                fieldValue: value,
                code: this.$publicCodeInput.value,
                type: type
            },
            success: (response) => {
                if (response.success) {
                    this.$codeHelp.removeClass('d-none');
                    this.$codeInput[0].disabled = false;
                    if ('resend' === type) {
                        this.$publicCodeInput.value = response.code;
                        this.$codeInput[0].classList.remove('is-valid');
                    }
                }

            }
        })
    }

    checkCode() {
        const value = this.$codeInput[0].value.trim().replace(' ', '');
        const fieldValue = this.$fieldInput[0].value.trim().replace(' ', '');
        if (value.length !== 6 || fieldValue.length < this.minLength) {
            this.$codeInput[0].classList.remove('is-valid');
        }
        $.ajax({
            url: this.checkCodeUrl,
            method: 'post',
            data: {
                code: this.$publicCodeInput.value,
                confirmCode: value,
                fieldValue: fieldValue
            },
            success: (response) => {
                if (response.success) {
                    this.$codeInput[0].classList.add('is-valid');
                    this.$codeInput[0].classList.remove('is-invalid');
                } else {
                    this.$codeInput[0].classList.remove('is-valid');
                }
            }
        })
    }
}